import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { AlgorithmFeedFormComponent } from './algorithm-feed-form.component';

/**
 * "Algorithm" admin screen. One tab per discovery feed; each tab embeds a
 * percentage-weight form (sum to 100). Changes save to the API and take
 * effect on the live feeds within ~1 minute (server cache TTL).
 */
@Component({
  selector: 'sa-algorithm',
  templateUrl: './algorithm.component.html',
  styleUrls: ['./algorithm.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatCardModule,
    AlgorithmFeedFormComponent,
  ],
})
export class AlgorithmComponent {}
